import {
    DefaultEventsMap,
    IEventManager,
    ISystemComponent,
    ComponentModuleViewConfig
} from '@gongxigames/framework/core/types';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';

export interface IView<EventsMap = DefaultEventsMap> extends IEventManager<EventsMap>, ISystemComponent {
    name?: string;

    configure(componentConfig: ComponentModuleViewConfig): void;

    onResourcesLoaded(): void;

    onLandscape(): void;

    onPortrait(): void;

    onResized(screenParams: ScreenParameters): void;

    getViewDependencies(): (symbol|string)[];
}
